import * as React from 'react';
import DashboardCard from './dashboardCard.component';
import CharitiesTable from '../charity/charity-list/CharitiesTable.component'
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import DashboardOverview from './DashboardOverview.component';
import CampaignsTable from '../campaign/CampaignsTable.component'


const styles = {
  cardsContainer: {
    margin: '70px 0px',
    display:'flex',
    justifyContent:'space-between'
  },
  heading: {
    marginTop: '60px'
  }
}
class DashboardComponent extends React.Component{

  render() {
    const { dashboardValues: {
      totalCharities, 
      totalDonations, 
      totalPlacements, 
      totalCampaigns,
      totalNoOfDonations,
      donations
      },
      classes,
      auth
    } = this.props;
    return (
      <div>
        <Typography variant="display1" className={classes.heading}>WELCOME TO DONACO DASHBOARD</Typography>
          {auth.isAdmin &&
            <div className={classes.cardsContainer}>
              <DashboardCard
                imgSrc="/assets/images/charity.jpg"
                amount={totalCharities}
                title="Total Charities"
                width={385}
              />
              <DashboardCard
                imgSrc="/assets/images/donations.jpg"
                amount={totalDonations || totalDonations === 0 ? `£ ${totalDonations}` : ''}
                title="Total Donations"
                width={385}
              />
              <DashboardCard
                imgSrc="/assets/images/widget.jpg"
                amount={totalPlacements}
                title="Widget Placements"
                width={385}
              />
              <DashboardCard
                imgSrc="/assets/images/image2.jpg"
                amount={totalCampaigns}
                title="Total Campaigns"
                width={385}
              />
            </div>
          }
          {!auth.isAdmin &&
            <div className={classes.cardsContainer}>
              <DashboardCard
                imgSrc="/assets/images/donations.jpg"
                amount={totalDonations || totalDonations === 0 ? `£ ${totalDonations}` : ''}
                title="Total Donations"
                width={515}
              />
              <DashboardCard
                imgSrc="/assets/images/users.jpg"
                amount={totalNoOfDonations}
                title="Number of Donations"
                width={515}
              />
              <DashboardCard
                imgSrc="/assets/images/image2.jpg"
                amount={totalCampaigns}
                title="Number of Campaigns"
                width={515}
              />
            </div>
          }
        <div style={{ display: 'flex'}}>
          <Card style={{width: '70%'}}>
            <CardContent>
              <div style={{display: 'flex', justifyContent:'space-between', borderBottom: '1px solid #ddd', paddingBottom: 22}}>
                <Typography variant="display1">{auth.isAdmin ? 'CHARITIES LIST' : 'CAMPAIGNS LIST' }</Typography>
                <Link to={auth.isAdmin ? 'charities' : 'campaigns'}><Button variant="outlined">VIEW ALL</Button></Link>
              </div>
              {auth.isAdmin ? <CharitiesTable /> : <CampaignsTable />}
            </CardContent>
          </Card>
          <DashboardOverview
            totalCampaigns={totalCampaigns}
            totalDonations={totalDonations}
            donations={donations}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DashboardComponent);